<template>
    <div>
        <MercenaryHeader :title="'활동 및 설정'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; padding:12px 12px 0px 12px; overflow:auto;">
            <div class="sub_title" style="margin-top:20px;">내 계정과 개인정보 관리<img :src="require('@/assets/img/setting_people.png')" style="width:11px; height:12px; margin-left:5px;"></div>
            <!-- <div style="display:flex; align-items: center; margin-bottom:10px;">
                <ProfileImage :image-path="image_path" :writer-type="member_type" style="width:40px; height:40px;" />
                <div @click="showProfileEdit" style="font-size:12px; font-weight:bold; margin-left:5px;">프로필 수정하기</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:6px; margin-left:5px;">
            </div> -->
            <div class="each_line" @click="() => { $GlobalStore.addModal('PrivacyInfo'); $Util.sendEventClick('활동및설정_개인정보') }">
                <div>개인정보</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('LoginSecurity'); $Util.sendEventClick('활동및설정_로그인_보안') }">
                <div>로그인 및 보안</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div v-if="is_temp_coach" class="each_line" @click="() => { $GlobalStore.addModal('ExpertInformation', { isModalBackTransparent: this.is_coach, isExpert: this.is_coach, status_bar_text_color : 'white' }); $Util.sendEventClick('활동및설정_수익정산') }">
                <div>전문가 등록 정보</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div v-if="!is_temp_coach" class="each_line" @click="() => { $GlobalStore.addModal('YouthFamilyAuth'); $Util.sendEventClick('활동및설정_유소년_가족_인증') }">
                <div>유소년 가족 인증</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <!--
            <div v-if="is_temp_coach" class="each_line" @click="() => {$GlobalStore.addModal('CoachRegister'); $Util.sendEventClick('활동및설정_코치등록및정보')}" >
                <div>코치 등록 및 정보</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div v-if="is_coach" class="each_line" @click="() => { $GlobalStore.addModal('CoachIntroduceManage'); $Util.sendEventClick('활동및설정_코치소개미디어') }">
                <div>코치 소개 미디어</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div> -->

            <div class="horizontal_line"></div>

            <div class="sub_title">내 활동 방식<img :src="require('@/assets/img/setting_handshake.png')" style="width:11px; height:10px; margin-left:5px;"></div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('TodayActivity'); $Util.sendEventClick('활동및설정_오늘의활동량') }">
                <div>오늘의 활동량</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('AlarmManage'); $Util.sendEventClick('활동및설정_알림') }">
                <div>알림 설정</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <!--
            <div class="each_line" @click="() => { $GlobalStore.addModal('ScheduleHistoryManage'); $Util.sendEventClick('활동및설정_스케줄참여관리') }">
                <div>스케줄 참여 관리</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            -->
            <div class="each_line" @click="() => { $GlobalStore.addModal('PaymentRegist'); $Util.sendEventClick('활동및설정_결제수단') }">
                <div>결제수단</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('PaymentDetailList'); $Util.sendEventClick('활동및설정_결제내역') }">
                <div>결제내역</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('SupportActivity'); $Util.sendEventClick('활동및설정_활동지원') }">
                <div>활동지원</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
             <div v-if="is_lesson_show" class="each_line" @click="() => { $GlobalStore.addModal('TempLessonList'); $Util.sendEventClick('활동및설정_수업') }">
                <div>수업</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>

            <!--<div class="horizontal_line"></div>-->

            <!--<div class="sub_title">내 활동 인사이트<img :src="require('@/assets/img/setting_chart.png')" style="width:14px; height:14px; margin-left:5px;"></div>-->
            <!--<div class="each_line">-->
            <!--<div>만보기</div>-->
            <!--<img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">-->
            <!--</div>-->
            <!--<div class="each_line">-->
            <!--<div>최근 내 활동</div>-->
            <!--<img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">-->
            <!--</div>-->

            <!-- <div class="horizontal_line"></div>
            <div class="sub_title">내 활동<img :src="require('@/assets/img/setting_chart.png')" style="width:13px; height:13px; margin-left:5px;"></div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('TodayActivity'); $Util.sendEventClick('활동및설정_오늘의활동량') }">
                <div>오늘의 활동량</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div> -->

            <!-- <div class="horizontal_line"></div> -->

            <!-- <div class="sub_title">다양한 정보와 고객지원<img :src="require('@/assets/img/setting_headset.png')" style="width:13px; height:13px; margin-left:5px;"></div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('Notification'); $Util.sendEventClick('활동및설정_공지사항') }">
                <div>공지사항</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
            <div class="each_line" @click="() => { $GlobalStore.addModal('ShowEvent'); $Util.sendEventClick('활동및설정_이벤트') }">
                <div>이벤트 및 배너 피드</div>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div> -->

            <div>
                <template v-if="$GlobalStore.loginInfo() && $GlobalStore.loginInfo().is_tester == '1'">
                    <div v-if="host_name === PRODUCTION_SERVER_HOST_NAME" @click="goToServer('test')" style="text-decoration: underline;padding:10px 0px;">테스트 서버로 이동</div>
                </template>
                <div v-if="host_name === TEST_SERVER_HOST_NAME" @click="goToServer('production')" style="text-decoration: underline; padding:10px 0px; margin-top:10px;">운영 서버로 이동</div>
            </div>

            <div style="font-size:11px; font-weight:500; line-height:18px; padding:20px 12px; background-color: #EBEBEB; margin-left:-12px; margin-right:-12px;margin-top:20px;">
                <span style="font-weight:bold;">사커하우</span><br>
                대표이사 : 심우철<br>
                (06289) 서울특별시 강남구 남부순환로 2912<br>
                통신판매업신고번호 : 2024-서울강남-06806<br>
                사업자등록번호 : 679-26-01595<br>
                대표 이메일 : SH_support@obyungear.com | 고객센터 : 02-588-5416
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "../../common/MercenaryHeader";
// import ProfileImage from "../../common/ProfileImage";
import { TEST_SERVER_HOST_NAME } from "../../../Constants";
import { initialRouteStr } from "../../../Constants";

export default {
    name: "ActivityAndSettings",
    components: { MercenaryHeader },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            TEST_SERVER_HOST_NAME: TEST_SERVER_HOST_NAME,
            PRODUCTION_SERVER_HOST_NAME: 'obyungear-user.ubiplus.co.kr'
        }
    },
    computed: {
        host_name() {
            if (location.hostname) {
                return window.location.hostname
            } else {
                return ''
            }
        },
        is_coach() {
            return this.$GlobalStore.loginInfo().is_coach == 1
            // return false
        },
        is_temp_coach() {
            return this.$GlobalStore.loginInfo().is_temp_coach == 1
        },
        member_type() {
            return this.$GlobalStore.loginInfo().member_type
        },
        image_path() {
            return this.$GlobalStore.loginInfo().image_path
        },
        is_lesson_show() {
            if (this.$GlobalStore.loginInfo()) {
                const branch_idx = this.$GlobalStore.loginInfo().branch_idx;
                if (branch_idx == '10') {
                    return true;
                } else if (branch_idx == '11') {
                    return true;
                }
            }
            return false;
        },
    },
    methods: {
        goToServer(type) {
            if (type === 'production') {
                location.href = location.protocol + '//' + this.PRODUCTION_SERVER_HOST_NAME + initialRouteStr + '?push_id_refresh=1&is_server_from=test';
            } else if (type === 'test') {
                this.$cookies.set('is_test_server', 1, 14 + 'y');
                const device = this.$cookies.get('device');
                const appv = this.$cookies.get('appv');
                location.href = location.protocol + '//' + TEST_SERVER_HOST_NAME + initialRouteStr + '?push_id_refresh=1&is_server_from=production&appv=' + appv + '&device=' + device;
            }
        },
        showProfileEdit() {
            this.$GlobalStore.addModal('MyProfileEdit', { memberIdx: this.$GlobalStore.loginInfo().idx, completeAction: this.completeAction })
        },

    }
}
</script>

<style scoped>
.sub_title {
    color: #210F03;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.each_line {
    display: flex;
    color: #210F03;
    font-size: 16px;
    padding: 8px 0px;
}

.each_line>div:nth-of-type(1) {
    flex: 1;
    font-weight: 500;
}

.horizontal_line {
    height: 1px;
    background-color: #EBEBEB;
    margin: 20px 0px;
}
</style>